import React, { useState, useRef } from 'react'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import SourceAnalysis from 'view/components/sourceAnalysis'
import StyleAnalysis from 'view/components/styleAnalysis'
import { getTeamInfo } from 'meinian-package/src/common/userInfo'
import PermissionsPage from 'view/components/permissionsPage'
import { SwitchPageTabContent } from 'view/components/switchTab'
import Dynamic from './dynamic'
import AnalysisFilter from '../../analysis/chooseAnalysis/analysisFilter'
import { SOURCE_TYPE } from '../../../../privateComponent/pieAttrChart'
import styles from './index.module.less'

export default ({ info }) => {
  const [tab, setTab] = useState(2)
  const [wrapParams, setWrapParams] = useState({
    inspirationId: info.id
  })
  const sourceRef = useRef(null)
  const sourceStyle = useRef(null)
  const teamInfo = getTeamInfo()
  const authAdmin = [1, 2].includes(Number(teamInfo.memberType))// 不是超级管理员和管理员的时候

  return <div className={styles['meinian-inspiration-analysis']}>
    <div className="meinian-inspiration-analysis-tab-wrap">
      <SwitchPageTabContent
        className="meinian-inspiration-analysis-tab"
        value={tab}
        options={[{ label: '动态', value: 2 }, { label: '分析', value: 1 }]}
        onChange={(val) => {
          setTab(val)
          setWrapParams({
            inspirationId: info.id
          })
        }}
      />
      {
        tab === 1 && <AnalysisFilter
          value={wrapParams}
          inspirationId={info.id}
          needMarkTimes={info.needMarkTimes}
          authAdmin={authAdmin}
          onChange={(val) => {
            sourceRef.current?.onUpdate?.(val)
            sourceStyle.current?.onUpdate?.({ ...wrapParams, ...val })
            setWrapParams(pre => ({ ...pre, ...val }))
          }}
        />
      }
    </div>
    {
      tab === 1 && <div>
        {
      !teamHasAuth('meinian_inspiration_analysis') ? <PermissionsPage type="analysis" style={{ marginLeft: 0, width: '100%', }} /> : <div className="meinian-inspiration-analysis-wrap-content">
        <SourceAnalysis
          baseParams={wrapParams}
          ref={sourceRef}
          pieSourceType={SOURCE_TYPE.INSPIRATION}
        />
        <StyleAnalysis
          style={{ marginTop: '16px', background: 'var(--m-fill-1)' }}
          baseParams={wrapParams}
          ref={sourceStyle}
        />
      </div>
    }
      </div>
    }
    {
      tab === 2 ? !teamHasAuth('meinian_inspiration_dynamic') ? <PermissionsPage type="dynamic" style={{ marginLeft: 0, width: '100%', }} /> : <Dynamic {...info} /> : null
    }
  </div>
}
